import { ROUTER_REDIRECT } from "../actions/router"

const router = (
    state = {
        redirect: null,
    },
    action
) => {
    switch (action.type) {
        case ROUTER_REDIRECT:
            return Object.assign({}, state, {
                redirect: action.to,
            });

        default:
            return state;
    }
};

export default router;

export const getRedirect = (state) => state.redirect;


// WEBPACK FOOTER //
// ./src/reducers/router.js